import React, { useEffect, useState } from "react";
import axios from "axios";

const coinList = ["bitcoin", "ethereum", "ripple", "xrp", "chainlink", "kadena", "hopr", "ondos"];

const calculateRSI = (closes) => {
  let gains = 0;
  let losses = 0;
  for (let i = 1; i < closes.length; i++) {
    const diff = closes[i] - closes[i - 1];
    if (diff > 0) gains += diff;
    else losses -= diff;
  }
  const rs = gains / (losses || 1);
  return 100 - 100 / (1 + rs);
};

export default function CryptoSignalDashboard() {
  const [data, setData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState("");

  const fetchData = async () => {
    const results = [];
    for (const coin of coinList) {
      try {
        const res = await axios.get(
          `https://api.coingecko.com/api/v3/coins/${coin}/market_chart?vs_currency=usd&days=7&interval=daily`
        );
        const prices = res.data.prices.map((p) => p[1]);
        const rsi = calculateRSI(prices);
        const signal = rsi > 50 ? "Above Zero" : rsi < 45 ? "Below Zero" : "Dead Zone";

        results.push({
          name: coin,
          price: prices[prices.length - 1].toFixed(4),
          rsi: rsi.toFixed(2),
          signal,
        });
      } catch (err) {
        results.push({ name: coin, price: "N/A", rsi: "N/A", signal: "Error" });
      }
    }
    setData(results);
    setLastUpdated(new Date().toLocaleTimeString());
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 15 * 60 * 1000); // 15 minutes
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4">
      <h1 className="text-2xl font-bold mb-2">Logan's Dark Mode Crypto Scanner</h1>
      <button
        onClick={fetchData}
        className="mb-4 px-4 py-2 bg-green-600 rounded hover:bg-green-700"
      >
        Manual Refresh
      </button>
      <p className="text-sm text-gray-400 mb-4">Last updated at: {lastUpdated}</p>
      <table className="w-full border text-sm">
        <thead>
          <tr className="bg-gray-800">
            <th className="p-2 border border-gray-700">Coin</th>
            <th className="p-2 border border-gray-700">Price (USD)</th>
            <th className="p-2 border border-gray-700">RSI</th>
            <th className="p-2 border border-gray-700">Signal</th>
          </tr>
        </thead>
        <tbody>
          {data.map((coin, i) => {
            const colorClass =
              coin.signal === "Above Zero"
                ? "text-green-400"
                : coin.signal === "Below Zero"
                ? "text-red-400"
                : "text-yellow-400";
            return (
              <tr key={i} className="text-center border border-gray-700">
                <td className="p-2 border border-gray-700 capitalize">{coin.name}</td>
                <td className="p-2 border border-gray-700">{coin.price}</td>
                <td className="p-2 border border-gray-700">{coin.rsi}</td>
                <td className={`p-2 border border-gray-700 font-bold ${colorClass}`}>
                  {coin.signal}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}